import React, { useEffect } from "react";
import styles from "./SeekerAwardsModalStyles.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import { Spin } from "antd";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../Action";
import { ModalHeader } from "../../../Constants";

export default function SeekerAwardsModal() {
    const dispatch = useDispatch();
    const { advanceFilterModalToggle,getUserBadgesSeekerData } = bindActionCreators(Actions, dispatch);
    const modalState = useSelector((state) => state.domain);
    const awardsState = useSelector((state) => state.seekerAwards);

    useEffect(()=>{

        return(()=>{
            getUserBadgesSeekerData([])
        })
    },[])

    return (
        <>
            <Modal show={modalState.modalState}
                onHide={() => advanceFilterModalToggle({ bool: false, value: "" })} 
                centered={true}
                size={"lg"}>
                <Modal.Header
                    closeButton
                >
                    <Modal.Title style={ModalHeader.styles}>
                        <span class="fa fa-trophy" aria-hidden="true" style={{marginRight:'10px'}}></span>Seeker Awards
                    </Modal.Title>
                </Modal.Header>
                <Spin
              spinning={awardsState?.isLoading}
              style={{
                marginTop: "30px",
                width: "100%",
              }}
            >
                <ModalBody className={styles.awardsModalBody}>
                    <div style={{color:'#5C667B', fontSize:'18px', textAlign:'center', marginBlock:'5px'}}>Active engagement fosters reusable knowledge. These awards honor your contributions</div>
                    <div className={styles.profileinfo}>
                        <div className="row">
                            <div className="col-md-4" >
                                <div className={styles.awardheadings}>Category</div>
                            </div>
                            <div className="col-md-4">
                                <div className={styles.awardheadings}>Badge</div>
                            </div>
                            <div className="col-md-4">
                                <div className={styles.awardheadings}>Progress</div>
                            </div>
                        </div>
                        {
                            awardsState.awardsData !== null &&
                            awardsState.awardsData.map((k, i) => {
                                return (
                                    <>
                                        <div key={i} className="row" style={{ alignItems: "center" }}>
                                            <div className="col-md-4" style={{ textAlign: "center",fontSize:"14px",fontFamily:"inter" }}>
                                                {k.category}
                                            </div>
                                            <div className="col-md-4" style={{ padding: "12px", textAlign: "center" }}>
                                                {k.category &&
                                                    k.category === 'Curious Mind' && k.level === 3 &&
                                                    <img title="Bronze Level" style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/curious_mind_bage_brownz.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Helping Hand' && k.level === 3 &&
                                                    <img title='Bronze Level' style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/helping_hand_badge_brownz.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Engagement' && k.level === 3 &&
                                                    <img title='Bronze Level' style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/most_liked_badge_brownz.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Curious Mind' && k.level === 2 &&
                                                    <img title='Silver Level' style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/curious_mind_bage_silver.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Helping Hand' && k.level === 2 &&
                                                    <img title='Silver Level' style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/helping_hand_badge_silver.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Engagement' && k.level === 2 &&
                                                    <img title="Silver Level" style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/most_liked_badge_silver.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Curious Mind' && k.level === 1 &&
                                                    <img title="Gold Level" style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/curious_mind_bage_gold.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Helping Hand' && k.level === 1 &&
                                                    <img title="Gold Level" style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/helping_hand_badge_gold.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Engagement' && k.level === 1 &&
                                                    <img title="Gold Level" style={{ width: "60px", textAlign: "center" }} src={require('../../../Images/most_liked_badge_gold.png')} />
                                                }
                                                {k.category &&
                                                    k.category === 'Curious Mind' && k.level === -1 &&
                                                    <div style={{ display: "flex", justifyContent:'center',alignItems:'center',height:'60px' }}>-</div>
                                                }
                                                {k.category &&
                                                    k.category === 'Helping Hand' && k.level === -1 &&
                                                    <div style={{ display: "flex", justifyContent:'center',alignItems:'center',height:'60px' }}>-</div>
                                                }
                                                {k.category &&
                                                    k.category === 'Engagement' && k.level === -1 &&
                                                    <div style={{ display: "flex", justifyContent:'center',alignItems:'center',height:'60px' }}>-</div>
                                                }
                                            </div>
                                            {
                                                k.nextAwardLevelCount !== null ?
                                                    <>
                                                        <div className="col-md-4" style={{ marginTop: "auto", marginBottom: "auto"}}>
                                                            <div class="progress" style={{ height: "20px", borderRadius: "3px", width: "100%" }} role="progressbar" aria-label="Warning striped example" aria-valuenow={(k.currentLevelCount / k.nextAwardLevelCount) * 100} aria-valuemin="0" aria-valuemax="100">
                                                                <div class="progress-bar progress-bar-striped bg-warning progress-bar-animated" style={{ width: `${k.currentLevelCount / k.nextAwardLevelCount * 100}%` }}></div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="col-md-4" style={{ marginTop: "auto", marginBottom: "auto" }}>
                                                            <div class="progress" style={{ height: "20px", borderRadius: "3px", width: "100%" }} role="progressbar" aria-label="Warning striped example" aria-valuenow={(k.currentLevelCount / k.nextAwardLevelCount) * 100} aria-valuemin="0" aria-valuemax="100">
                                                                <div class="progress-bar progress-bar-striped bg-warning progress-bar-animated" style={{ width: "100%" }}></div>
                                                            </div>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </ModalBody>
                </Spin>
            </Modal>
        </>
    )
}